// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2qo-X","inputWrap":"styles_inputWrap__31ajL","input":"styles_input__10Q_L"};